module.exports = __webpack_public_path__ + "static/nathaniel-ce3b8a93a0c79025e5b3038e809f4c15.svg";